/* ============================================================================
   ROWMAN — product
   Variant selection, the 3D media carousel, collection filtering and the
   notify-me form. Every value shown (price, availability, SKU, options) comes
   from Shopify's variant JSON rendered by Liquid. Nothing is hard-coded.
   ============================================================================ */
(function () {
  'use strict';

  var R = window.ROWMAN;
  if (!R) return;

  var strings = R.strings || {};

  /* ═══════════════════ MODULE: variant picker ═══════════════════
     Replaces the prototype's hard-coded S / M / L / XL buttons. Renders the
     same .size-btn / .cw-swatch treatment, driven by real product options. */

  R.register({
    name: 'VariantPicker',
    scope: '[data-variant-picker]',
    mount: function (root) {
      var dataEl = document.getElementById(root.getAttribute('data-variant-data'));
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); }
      catch (e) { console.error('[ROWMAN] variant data parse failed', e); return; }

      var sectionId = root.getAttribute('data-section-id');
      var productUrl = root.getAttribute('data-product-url');
      var idInput = document.querySelector('[data-variant-id-input][data-section-id="' + sectionId + '"]');
      var priceEl = document.querySelector('[data-variant-price][data-section-id="' + sectionId + '"]');
      var skuEl = document.querySelector('[data-variant-sku][data-section-id="' + sectionId + '"]');
      var addBtn = document.querySelector('[data-add-button][data-section-id="' + sectionId + '"]');
      var availEl = document.querySelector('[data-variant-availability][data-section-id="' + sectionId + '"]');
      var notifyWrap = document.querySelector('[data-notify-wrap][data-section-id="' + sectionId + '"]');
      var notifyVariant = document.querySelector('[data-notify-variant][data-section-id="' + sectionId + '"]');

      function selectedOptions() {
        var picked = [];
        root.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          var active = group.querySelector('[data-option-value].is-active, [data-option-value][aria-checked="true"]');
          picked[idx] = active ? active.getAttribute('data-option-value') : null;
        });
        return picked;
      }

      function matchVariant(picked) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < picked.length; j++) {
            if (picked[j] === null) continue;
            if (v.options[j] !== picked[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      /* Disable option values that cannot combine with the current selection,
         so a shopper can never land on a non-existent variant. */
      function refreshAvailability(picked) {
        root.querySelectorAll('[data-option-index]').forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          group.querySelectorAll('[data-option-value]').forEach(function (btn) {
            var test = picked.slice();
            test[idx] = btn.getAttribute('data-option-value');
            var exists = variants.some(function (v) {
              for (var j = 0; j < test.length; j++) {
                if (test[j] === null) continue;
                if (v.options[j] !== test[j]) return false;
              }
              return true;
            });
            var inStock = variants.some(function (v) {
              for (var j = 0; j < test.length; j++) {
                if (test[j] === null) continue;
                if (v.options[j] !== test[j]) return false;
              }
              return v.available;
            });
            btn.classList.toggle('is-unavailable', !exists);
            btn.classList.toggle('is-soldout', exists && !inStock);
            if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') btn.disabled = !exists;
          });
        });
      }

      function apply(variant, pushState) {
        if (idInput) idInput.value = variant ? variant.id : '';

        if (!variant) {
          if (addBtn) {
            addBtn.disabled = true;
            addBtn.setAttribute('data-state', 'unavailable');
            var lbl0 = addBtn.querySelector('[data-add-label]');
            if (lbl0) lbl0.textContent = strings.unavailable || 'Unavailable';
          }
          if (availEl) availEl.textContent = strings.unavailable || 'Unavailable';
          return;
        }

        if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
        if (skuEl) {
          skuEl.textContent = variant.sku || '—';
          skuEl.closest('[data-sku-row]')?.toggleAttribute('hidden', !variant.sku);
        }

        var preorder = root.getAttribute('data-preorder') === 'true';
        var label = addBtn ? addBtn.querySelector('[data-add-label]') : null;

        if (addBtn) {
          addBtn.disabled = !variant.available;
          if (variant.available) {
            addBtn.setAttribute('data-state', preorder ? 'preorder' : 'available');
            if (label) label.textContent = preorder
              ? (strings.preorder || 'Pre-order')
              : (strings.addToCart || 'Add to Cart');
          } else {
            addBtn.setAttribute('data-state', 'soldout');
            if (label) label.textContent = strings.soldOut || 'Sold Out';
          }
        }

        if (availEl) {
          availEl.textContent = variant.available
            ? (preorder ? (strings.preorderNote || 'Pre-order — ships on release')
                        : (strings.inStock || 'In stock'))
            : (strings.soldOut || 'Sold Out');
          availEl.setAttribute('data-available', variant.available ? 'true' : 'false');
        }

        if (notifyWrap) notifyWrap.hidden = variant.available;
        if (notifyVariant) notifyVariant.value = variant.id;

        // switch the media stage to the variant's own image when it has one
        if (variant.featured_media_id) {
          document.dispatchEvent(new CustomEvent('rowman:variant:media', {
            detail: { sectionId: sectionId, mediaId: variant.featured_media_id }
          }));
        }

        if (pushState && productUrl && window.history.replaceState) {
          window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
        }

        document.dispatchEvent(new CustomEvent('rowman:variant:change', {
          detail: { variant: variant, sectionId: sectionId }
        }));
      }

      function onPick(e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        if (btn.classList.contains('is-unavailable')) return;

        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
/* Keep the visible colorway name synchronized */
if (group.classList.contains('colorway-selector')) {
  var colorLabel = group.previousElementSibling
    ? group.previousElementSibling.querySelector('.colorway-selected')
    : null;

  if (colorLabel) {
    colorLabel.textContent = btn.getAttribute('data-option-value');
  }
}
        var picked = selectedOptions();
        refreshAvailability(picked);
        apply(matchVariant(picked), true);
      }

      /* Arrow-key navigation within an option group (radiogroup semantics) */
      function onKey(e) {
        if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'].indexOf(e.key) === -1) return;
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        var group = btn.closest('[data-option-index]');
        var items = Array.prototype.filter.call(
          group.querySelectorAll('[data-option-value]'),
          function (b) { return !b.classList.contains('is-unavailable'); }
        );
        var i = items.indexOf(btn);
        if (i === -1) return;
        e.preventDefault();
        var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown')
          ? items[(i + 1) % items.length]
          : items[(i - 1 + items.length) % items.length];
        next.focus();
        next.click();
      }

      root.addEventListener('click', onPick);
      root.addEventListener('keydown', onKey);

      var initial = selectedOptions();
      refreshAvailability(initial);
      apply(matchVariant(initial), false);

      return function () {
        root.removeEventListener('click', onPick);
        root.removeEventListener('keydown', onKey);
      };
    }
  });

  /* ═══════════════════ MODULE: product media carousel ═══════════════════
     Preserves the prototype's 3D right-to-left transition. Mounts only when
     the product has two or more media items, exactly as before. */

  R.register({
    name: 'ProductCarousel',
    scope: '[data-product-carousel]',
    mount: function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pc-slide]'));
      if (slides.length < 2) return;
var stage = root.closest('.product-image-stage');

if (stage) {
  stage.classList.add('has-carousel');
}

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pc-dot]'));
      var prev = root.querySelector('[data-pc-prev]');
      var next = root.querySelector('[data-pc-next]');
      var counter = root.querySelector('.pis-counter');
      var sectionId = root.getAttribute('data-section-id');
      var index = 0;
      var animating = false;

      function show(target, dir) {
        if (animating || target === index) return;
        var total = slides.length;
        target = ((target % total) + total) % total;
        animating = true;

        var out = slides[index];
        var incoming = slides[target];

        if (!R.motionAllowed()) {
          out.classList.remove('is-active');
          incoming.classList.add('is-active');
          index = target;
          animating = false;
          sync();
          return;
        }

        out.classList.remove('is-active');
        out.classList.add(dir > 0 ? 'is-exit-left' : 'is-exit-right');
        incoming.classList.add(dir > 0 ? 'is-enter-right' : 'is-enter-left');

        requestAnimationFrame(function () {
          incoming.classList.add('is-active');
          incoming.classList.remove('is-enter-right', 'is-enter-left');
        });

        setTimeout(function () {
          out.classList.remove('is-exit-left', 'is-exit-right');
          index = target;
          animating = false;
          sync();
        }, 620);
      }

      function sync() {
        slides.forEach(function (s, i) {
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      function onPrev(e) { e.preventDefault(); show(index - 1, -1); }
      function onNext(e) { e.preventDefault(); show(index + 1, 1); }
      function onDot(e) {
        var d = e.target.closest('[data-pc-dot]');
        if (!d) return;
        e.preventDefault();
        var t = dots.indexOf(d);
        show(t, t > index ? 1 : -1);
      }
      function onKey(e) {
        if (e.key === 'ArrowLeft') show(index - 1, -1);
        if (e.key === 'ArrowRight') show(index + 1, 1);
      }
      function onVariantMedia(e) {
        if (e.detail.sectionId !== sectionId) return;
        var t = slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === String(e.detail.mediaId);
        });
        if (t > -1) show(t, t > index ? 1 : -1);
      }

      // touch swipe
      var startX = null;
      function onTouchStart(e) { startX = e.touches[0].clientX; }
      function onTouchEnd(e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        startX = null;
      }

      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);
      root.addEventListener('click', onDot);
      root.addEventListener('keydown', onKey);
      root.addEventListener('touchstart', onTouchStart, { passive: true });
      root.addEventListener('touchend', onTouchEnd, { passive: true });
      document.addEventListener('rowman:variant:media', onVariantMedia);
      sync();

      return function () {
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        root.removeEventListener('click', onDot);
        root.removeEventListener('keydown', onKey);
        root.removeEventListener('touchstart', onTouchStart);
        root.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('rowman:variant:media', onVariantMedia);
      };
    }
  });

  /* ═══════════════════ MODULE: collection filters ═══════════════════
     Preserved from the prototype. Filters .chamber cards by data-cat within
     the section. Cards are Liquid-rendered from the Shopify collection, so
     the filter operates on real products and real tags. */

  R.register({
    name: 'CollectionFilters',
    scope: '[data-collection-filters]',
    mount: function (nav) {
      var scopeSel = nav.getAttribute('data-cf-target');
      var scope = scopeSel ? document.querySelector(scopeSel) : nav.closest('.collection-page');
      if (!scope) scope = document;

      var links = Array.prototype.slice.call(nav.querySelectorAll('[data-cf-cat]'));
      var empty = scope.querySelector('.cf-empty');

      function apply(cat) {
        var shown = 0;
        scope.querySelectorAll('.chamber').forEach(function (card) {
          var cats = (card.getAttribute('data-cat') || '').split(/\s+/);
          var match = cat === 'all' || cats.indexOf(cat) !== -1;
          card.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.hidden = shown > 0;
        links.forEach(function (l) {
          var on = l.getAttribute('data-cf-cat') === cat;
          l.classList.toggle('is-active', on);
          l.setAttribute('aria-current', on ? 'true' : 'false');
        });
        R.announce(shown + ' ' + (strings.productsShown || 'products shown'));
      }

      function onClick(e) {
        var link = e.target.closest('[data-cf-cat]');
        if (!link) return;
        e.preventDefault();
        apply(link.getAttribute('data-cf-cat'));
      }

      nav.addEventListener('click', onClick);
      var active = nav.querySelector('[data-cf-cat].is-active');
      apply(active ? active.getAttribute('data-cf-cat') : 'all');

      return function () { nav.removeEventListener('click', onClick); };
    }
  });

  /* ═══════════════════ MODULE: notify-me (sold out / locked) ═══════════════════
     Posts to Shopify's customer form with a back-in-stock tag so the request
     is captured in the customer list. */

  R.register({
    name: 'NotifyForm',
    scope: '[data-notify-form]',
    mount: function (form) {
      function onSubmit() {
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.classList.add('rw-btn-loading');
      }
      form.addEventListener('submit', onSubmit);
      return function () { form.removeEventListener('submit', onSubmit); };
    }
  });

  /* ═══════════════════ MODULE: quantity stepper ═══════════════════ */

  R.register({
    name: 'QuantityStepper',
    scope: '[data-qty-stepper]',
    mount: function (root) {
      var input = root.querySelector('input[type="number"]');
      function onClick(e) {
        var btn = e.target.closest('[data-qty-step]');
        if (!btn || !input) return;
        e.preventDefault();
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + step));
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      root.addEventListener('click', onClick);
      return function () { root.removeEventListener('click', onClick); };
    }
  });

}());
